import { Locales } from '@griply/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/components/ui/custom-form-select';

export const useSupportedLanguageOptions = () => {
  const { t } = useTranslation();

  return useMemo<Option[]>(() => {
    const otherLanguages: Option[] = [
      {
        value: Locales.NlNL,
        label: t('general.labels.languages.nl-nl'),
      },
      {
        value: Locales.EsES,
        label: t('general.labels.languages.es-es'),
      },
      {
        value: Locales.DeDE,
        label: t('general.labels.languages.de-de'),
      },
      {
        value: Locales.PlPL,
        label: t('general.labels.languages.pl-pl'),
      },
      {
        value: Locales.FrFR,
        label: t('general.labels.languages.fr-fr'),
      },
      {
        value: Locales.PtPT,
        label: t('general.labels.languages.pt-pt'),
      },
      {
        value: Locales.PtBR,
        label: t('general.labels.languages.pt-br'),
      },
      {
        value: Locales.ItIT,
        label: t('general.labels.languages.it-it'),
      },
      {
        value: Locales.SvSE,
        label: t('general.labels.languages.sv-se'),
      },
      {
        value: Locales.NbNO,
        label: t('general.labels.languages.nb-no'),
      },
      {
        value: Locales.DaDK,
        label: t('general.labels.languages.da-dk'),
      },
    ].sort((a, b) => a.label.localeCompare(b.label));

    return [
      {
        value: Locales.EnUS,
        label: t('general.labels.languages.en-us'),
        // splits the menu into its own PopupMenuList, above the other languages
        hasBottomSeparator: true,
      },
      ...otherLanguages,
    ];
  }, [t]);
};
